import React from 'react';
import a10Mobile from './assets/a10-mobile-resized2.png';

const ResponsiveSilhouette = () => {
  return (
    <div className="silhouette-container">
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${a10Mobile})`,
          backgroundPosition: 'bottom center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
        }}
      />
    </div>
  );
};

export default ResponsiveSilhouette;